// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSenderReputationRequestToJson, getSenderReputationResponseFromJson, listSendGridSubUserReputationsRequestToJson, listSendGridSubUserReputationsResponseFromJson, listSendGridTeammatesRequestToJson, listSendGridTeammatesResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function listSendGridTeammates(request) {
    const raw = await fetchRpc('email.v1.SendGridService/ListSendGridTeammates', listSendGridTeammatesRequestToJson(request));
    return listSendGridTeammatesResponseFromJson(raw);
}
export function listSendGridTeammates$(request, options) {
    return defer(() => listSendGridTeammatesWithTransport$(getGlobalTransport(), request, options));
}
export function listSendGridTeammatesWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.SendGridService/ListSendGridTeammates', listSendGridTeammatesRequestToJson(request), options)
        .pipe(map(resp => listSendGridTeammatesResponseFromJson(resp)));
}
export async function listSendGridSubUserReputations(request) {
    const raw = await fetchRpc('email.v1.SendGridService/ListSendGridSubUserReputations', listSendGridSubUserReputationsRequestToJson(request));
    return listSendGridSubUserReputationsResponseFromJson(raw);
}
export function listSendGridSubUserReputations$(request, options) {
    return defer(() => listSendGridSubUserReputationsWithTransport$(getGlobalTransport(), request, options));
}
export function listSendGridSubUserReputationsWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.SendGridService/ListSendGridSubUserReputations', listSendGridSubUserReputationsRequestToJson(request), options)
        .pipe(map(resp => listSendGridSubUserReputationsResponseFromJson(resp)));
}
export async function getSenderReputation(request) {
    const raw = await fetchRpc('email.v1.SendGridService/GetSenderReputation', getSenderReputationRequestToJson(request));
    return getSenderReputationResponseFromJson(raw);
}
export function getSenderReputation$(request, options) {
    return defer(() => getSenderReputationWithTransport$(getGlobalTransport(), request, options));
}
export function getSenderReputationWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.SendGridService/GetSenderReputation', getSenderReputationRequestToJson(request), options)
        .pipe(map(resp => getSenderReputationResponseFromJson(resp)));
}
